import { Injectable } from "@angular/core";
import { StorageService } from "./storage.service";
import { Plugins } from "@capacitor/core";
import { Subject } from "rxjs";

const { Storage } = Plugins;
@Injectable()
export class SQLiteStorageService implements StorageService {
	private data: object = {};
	private STORAGE_KEY = "pos_key";
	private $subject = new Subject<{
		key: string;
		oldValue: string;
		newValue: string;
	}>();

	public getItem(key: string): string {
		return this.data[key];
	}

	public setItem(key: string, value: string): void {
		const oldValue = this.data[key];
		this.data[key] = value;
		this.$subject.next({
			key,
			oldValue,
			newValue: value
		});
		this.commitData();
	}

	public removeItem(key: string): void {
		const oldValue = this.data[key];
		this.data[key] = undefined;
		this.$subject.next({
			key,
			oldValue,
			newValue: undefined
		});
		this.commitData();
	}

	public get onChangeStorageData() {
		return this.$subject;
	}

	public setItemAsync(key: string, value: string): Promise<void> {
		throw new Error("Haven't implement");
	}

	public getItemAsync(key: string): Promise<string> {
		throw new Error("Haven't implement");
	}

	public async initialize(): Promise<boolean> {
		const data = await Storage.get({ key: this.STORAGE_KEY });
		if (data && data.value) {
			this.data = JSON.parse(data.value);
			return true;
		}
		this.data = {};
		return true;
	}

	private commitData() {
		Storage.set({
			key: this.STORAGE_KEY,
			value: JSON.stringify(this.data)
		});
	}
}
